export const MAXIMUM_FILE_UPLOAD_SIZE = 10;

export const ALLOWED_FILE_TYPES =
  'text/csv, text/plain, application/pdf, text/rtf, application/msword,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,' +
  'image/png, image/jpeg, image/jpg';
